import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux'

import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Radio from '@material-ui/core/Radio'
import FormLabel from '@material-ui/core/FormLabel'

import RadioGroup from '@material-ui/core/RadioGroup'
import { connect } from 'react-redux'

import DialogContent from '@material-ui/core/DialogContent'
import { homeActions } from '../../actions/home.actions'
import { userActions } from '../../actions/user.actions'
import { injectStripe } from 'react-stripe-elements'
import { Elements } from 'react-stripe-elements'
import StripeCardsSection from '../StripeCardsSection'
import t from 'tcomb-form'
import templates from '../../containers/formTemplate'
import { getProjectId } from '../../selectors/project.selector'
import { getProfile } from '../../selectors/profile.selector'

t.form.Form.templates = templates

class _CheckoutForm extends React.Component {
  state = {
    subscriptionValue: 'Brick'
  }

  handleChange = event => {
    this.setState({ subscriptionValue: event.target.value })
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(homeActions.closeChangeSubscriptionDialog())
  }

  onCreateSubClick() {
    const { dispatch, projectId } = this.props
    const { subscriptionValue } = this.state
    this.props.stripe.createToken().then(({ token }) => {
      if (!token) return

      dispatch(
        userActions.createSubscription(token.id, projectId, subscriptionValue)
      )
    })
  }

  render() {
    return (
      <React.Fragment>
        <DialogContent>
          <FormControl component='fieldset'>
            <FormLabel component='legend'>Subscription</FormLabel>
            <RadioGroup
              onChange={this.handleChange}
              value={this.state.subscriptionValue}
              name='subscriptionGroup'>
              <FormControlLabel
                value='Brick'
                control={<Radio color='primary' />}
                label='Brick - $10 per User - 10 User Max'
              />
              <FormControlLabel
                value='Steel'
                control={<Radio color='primary' />}
                label='Steel - $15 per User - Unlimited User Max'
              />
            </RadioGroup>
          </FormControl>
          <StripeCardsSection />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeDialog.bind(this)} color='primary'>
            Cancel
          </Button>
          <Button onClick={this.onCreateSubClick.bind(this)} color='primary'>
            Ok
          </Button>
        </DialogActions>
      </React.Fragment>
    )
  }
}

const CheckoutFormComponent = injectStripe(_CheckoutForm)

class ChangeSubscriptionDialog extends React.Component {
  closeDialog() {
    const { dispatch } = this.props
    dispatch(homeActions.closeChangeSubscriptionDialog())
  }

  render() {
    const { isChangeSubDialogOpen } = this.props
    return (
      <Dialog
        open={!!isChangeSubDialogOpen}
        fullWidth={true}
        maxWidth={'sm'}
        onBackdropClick={this.closeDialog.bind(this)}
        >
        <DialogTitle>Enter Payment Information</DialogTitle>
        <Elements>
          <CheckoutFormComponent  />
        </Elements>
      </Dialog>
    )
  }
}

export default compose(
  connect((state, props) => {

    return {
      profile: getProfile(state),
      projectId: getProjectId(state),
      isChangeSubDialogOpen: state.homeView.isChangeSubDialogOpen,
    }
  }),
  withStyles(styles, { withTheme: true })
)(ChangeSubscriptionDialog)



// WEBPACK FOOTER //
// ./src/components/Dialogs/ChangeSubscriptionDialog.tsx